<div class="back">
  <h2>Get 10Web Pro plans</h2>
</div>

<p class="mt5 mb20" [innerHTML]="description"></p>

<ul class="points">
  <li *ngFor="let point of points">
    <i class="db-icon db-icon-ds-checkmark-bg"></i>
    <div>
      <p><b [innerHTML]="point.title"></b></p>
      <p *ngIf="point.desc" [innerHTML]="point.desc"></p>
      <ul *ngIf="point.subPoints" class="sub-points">
        <li *ngFor="let subPoint of point.subPoints">
          <p [innerHTML]="subPoint"></p>
        </li>
      </ul>
    </div>
  </li>
</ul>

<div class="text-center mb30 mt30">
  <button class="ds-btn-blue ds-btn-xl rectangle" (click)="onStepChange.emit('plans')">
    <span>Get 10Web Pro</span>
  </button>
</div>
